import { useNavigate } from 'react-router-dom';
import { AuthForgotPassword } from '@lightning/ui';
import { toast } from 'sonner';
import { howieAuthBrand } from '../config/authBrand';
import { getHowiePasswordResetRedirectUrl } from '../config/authRedirects';
import { supabase } from '../services/supabase';

export default function ForgotPasswordPage() {
  const navigate = useNavigate();

  return (
    <AuthForgotPassword
      brand={howieAuthBrand}
      onSubmit={async (email) => {
        const { error } = await supabase.auth.resetPasswordForEmail(email, {
          redirectTo: getHowiePasswordResetRedirectUrl(),
        });

        if (error) {
          toast.error(error.message || 'Failed to send reset email');
          throw error;
        }

        toast.success('Check your email for the password reset link');
      }}
      onNavigateToSignIn={() => navigate('/login')}
    />
  );
}
